import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import { GlobalStyles } from '@mui/material';

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles styles={{ '.grecaptcha-badge': { visibility: 'hidden !important', opacity: '0 !important', pointerEvents: 'none !important' } }} />
      <CssBaseline /> {/* Ensures consistent baseline styling */}
      <App />
    </ThemeProvider>  </React.StrictMode>
);